import { BannerType } from '@/app/entities/Banner'
import { BannerSection } from './BannerSection'

export const BannersPage = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex grid-cols-3 flex-col gap-4 xl:grid">
        <BannerSection type={BannerType.INITIAL_PAGE} title="Tela Inicial" />

        <BannerSection type={BannerType.INVITE} title="Convite" />
        <BannerSection
          type={BannerType.DASHBOARD_MODAL}
          title="Modal Dashboard"
        />
      </div>
      <BannerSection type={BannerType.LOGIN} title="Login" />
      <BannerSection
        type={BannerType.DASHBOARD_CARD}
        title="Dashboard Aplicativo"
      />
    </div>
  )
}
